import { HttpClient } from "@angular/common/http";
import { BaseApiService } from "../base-api.service";
import { Injectable } from "@angular/core";
import { environment } from '@beyou/environments/environment';
import { AdminStats } from "../../models/stats/admin-stats.model";
import { firstValueFrom, map, Observable } from "rxjs";
import { AdminStatsMapper } from "../../mappers/stats/admin-stats.mapper";
import { AdminStatsDto } from "../../dto/stats/admin-stats.dto";
import { SessionLengthStatsDto } from "../../dto/stats/session-length-stats.dto";
import { SessionLengthStats } from "../../models/stats/session-length-stats.model";
import { SessionLengthStatsMapper } from "../../mappers/stats/session-length-stats.mapper";

@Injectable({
  providedIn: 'root'
})
export class AdminStatsApiService extends BaseApiService {

  constructor(http: HttpClient) { 
    super(http);
  }

  public async getAdminStats(): Promise<AdminStats> {
    const apiUrl = `${environment.adminApiBaseUrl}/stats/overview`;
    return await firstValueFrom(this.http.get<AdminStatsDto>(apiUrl).pipe(
      map((response) => {
        console.debug('Admin stats retrieved: ', response);
        return AdminStatsMapper.toModel(response);
      })
    ));
  }

  public getSessionLengthStats(): Observable<SessionLengthStats[]> {
      const apiUrl = `${environment.adminApiBaseUrl}/stats/session-length`;
      return this.getAllPagedData<SessionLengthStatsDto>(apiUrl).pipe(
        map((response) => {
          return response.filter(item => !!item.preferred_session_duration).map(item => {
            return SessionLengthStatsMapper.toModel(item);
          })
        })
      );
    }
}